
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fQp22", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.8c25f1d7.js.map
